import React from "react"

export default class AssessmentScore extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			
		};
	}

	componentDidMount() {
		var self = this;

		$(this.refs.popover).on('click', function () {
			bootbox.alert({
				size: 'small',
				message: `
				<div style="font-size:21px;line-height:31px;text-align:center;"><label>Knowledge:</label> ${self.props.results.knowledge}</div>
				<div style="font-size:21px;line-height:31px;text-align:center;"><label>Behavior:</label> ${self.props.results.behavior}</div>
				<div style="font-size:21px;line-height:31px;text-align:center;"><label>Confidence:</label> ${self.props.results.confidence}</div>
			`})
		});
	}



	render() {
		//console.log("AssessmentScore", this.props.results);

		return (
			<div className="assessment-score">
				<label>Your Financial Fitness Score</label>
				<a href="#" className="score" ref="popover">
					<div className="points">
						<span className="number">{this.props.results.score}</span>
						<span className="separator">/</span>
						<span className="number">10</span>
						<span className="points-label">pts</span>
					</div>
					<div className="current-score">Current Score</div>
				</a>
			</div>
		);
	}


}